import { ThemeProvider } from '@mui/material/styles';
import AppRoutes from 'routes';
import theme from './styles/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
